import { render, staticRenderFns } from "./Parcels.vue?vue&type=template&id=05e76bbe"
import script from "./Parcels.vue?vue&type=script&lang=js"
export * from "./Parcels.vue?vue&type=script&lang=js"
import style0 from "./Parcels.vue?vue&type=style&index=0&id=05e76bbe&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports